import * as React from 'react';
import { PanelContext } from './PanelContextProvider';
const usePanelContext = () => {
    const context = React.useContext(PanelContext);
    if (!context) {
        throw new Error('`usePanelContext` must be used within a <PanelContext.Provider />');
    }
    return context;
};
export { usePanelContext };
//# sourceMappingURL=usePanelContext.js.map